import dayjs   from "dayjs";
import fromNow from "dayjs/plugin/relativeTime";
import utc     from "dayjs/plugin/utc";

import _error                    from "_common/error";
import {
	getPopularGameCards,
	getTournaments,
	getAllBroadcastsByPackageName
} from "_services/api/broadcast";

// mapping session props for carousel and list of sessions
export const mapLivePageSessionProps = session => {
	const { id, sessionInfo, description, startTimeUTC, isLive, liveViews, broadcaster, thumbnail, isLeaderBoardLive } = session;

	const { name, photo, isCeleb } = broadcaster?.sportsFan;
	const mediaHref                = `/stream/${ id }`;
	const profileHref              = `/profile/${ broadcaster.sportsFan.id }`;

	dayjs.extend ( utc );
	dayjs.extend ( fromNow );

	return {
		title       : description ? description : sessionInfo,
		mediaSrc    : thumbnail,
		actorName   : name,
		actorImage  : photo,
		isCeleb,
		timeElapsed : dayjs ( dayjs.utc ( startTimeUTC ) ).fromNow (),
		mediaHref,
		profileHref,
		liveViews,
		isLive,
		isLeaderBoardLive
	};
};

export const getGameAndTournament =  async ( { defaultProps, gameCards, tournaments } ) => {
	let results;

	if ( defaultProps ) {
		results = await Promise.allSettled ( [ getGameCardApi.bind ( defaultProps ) ( { gameCards } ), getTournamentApi.bind ( defaultProps ) ( { tournaments } ) ] );
	} else {
		results = await Promise.allSettled ( [ getGameCardApi ( { gameCards } ), getTournamentApi ( { tournaments } ) ] );
	}

	let response = [];

	results.forEach ( result => {
		if ( result.status === "fulfilled" )
			response = response.concat ( result.value );
	} );

	return { response };
};

export const getDataForSpecificGameOrTournament =  async ( { response, id, defaultProps } ) => {
	try {
		const specificCardObject = response.find ( item => item?.id === parseInt ( id ) );

		if ( !specificCardObject )
			throw _error ( "Couldn't fetch Selected Game data. Please try refreshing the page" );

		let sessionList = [];

		if ( specificCardObject.cardType === "tournament" ) {
			if ( defaultProps )
				sessionList = await getTournaments.bind ( defaultProps ) ( [ specificCardObject.cardId ] );
			 else
				sessionList = await getTournaments ( [ specificCardObject.cardId ] );

			sessionList = sessionList?.tournaments.find ( item => item.id === specificCardObject.cardId ).sessions || [];

		} else {
			if ( defaultProps )
				sessionList = await getAllBroadcastsByPackageName.bind ( defaultProps ) ( { androidPackageName: specificCardObject.androidPackageName, pageNo: 1, pageSize: 10 } );
			else
				sessionList = await getAllBroadcastsByPackageName ( { androidPackageName: specificCardObject.androidPackageName, pageNo: 1, pageSize: 10 } );
		}

		const finalRes = {
			...specificCardObject,
			sessions: sessionList
		};

		return finalRes;
	} catch ( error ) {
		return {
			sessions: []
		};
	}
};

export const formatOrderedLiveTabsData = data => {
	const gameCards   = [];
	const tournaments = [];

	for ( let i = 0; i < data.liveTabOrdering.length; i ++ ) {
		const _data = data.liveTabOrdering[i];

		switch ( _data.cardType ) {
			case "gameCard":
				gameCards.push ( _data );
				break;

			case "tournament":
				tournaments.push ( _data );
				break;
		}
	}

	return { gameCards, tournaments };
};

const formatSessionListWithGameOrTournament = ( filteredData, data ) => {
	const mapOfCards = {};

	for ( let i = 0; i < filteredData.length; i ++ ) {
		mapOfCards[filteredData[i].cardId] = filteredData[i];
	}

	const finalData = [];

	for ( let i = 0; i < data.length; i ++ ) {
		const __data = data[i];

		if ( __data?.sessions?.length < 1 )
			continue;

		finalData.push ( {
			...mapOfCards[data[i].id],
			...__data
		} );
	}

	return finalData;
};

const getGameCardApi = async function ( { gameCards } ) {
	if ( !gameCards || !gameCards.length ) return;

	let data;

	data =  await getPopularGameCards.bind ( this ) ( gameCards.map ( el => el.cardId ) );

	if ( !data || !data.length )
		throw _error ( "Couldn't fetch games data. Please try refreshing the page" );

	return formatSessionListWithGameOrTournament ( gameCards, data );
};

// Api call for getting sessions for Tournament carousel
const getTournamentApi = async function ( { tournaments } ) {
	if ( !tournaments || !tournaments.length ) return;

	let data;

	data =  await getTournaments.bind ( this ) ( tournaments.map ( el => el.cardId ) );

	if ( !data || !data.tournaments || !data.tournaments.length )
		throw _error ( "Couldn't fetch tournaments data. Please try refreshing the page" );

	return formatSessionListWithGameOrTournament ( tournaments, data.tournaments );
};
